<div class="container-fluid p-0 edit-profile-page">

    <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="showAssistant = true"
    />

    <!-- Moves aside when the assistant panel is docked open -->
    <div class="chatbot-push">
    <section class="container profile-sections py-4">
        <div class="card profile-hero-card p-4 mb-4 overflow-hidden">
            <div class="row g-4 align-items-center">
                <div class="col-lg-8 d-flex align-items-center gap-4 flex-column flex-md-row">
                    <div class="profile-avatar d-flex align-items-center justify-content-center flex-shrink-0">
                        <span class="profile-avatar-text text-white">{{ avatar_initials }}</span>
                    </div>

                    <div class="d-flex flex-column gap-2 text-center text-md-start">
                        <span class="badge rounded-pill profile-kicker align-self-center align-self-md-start fw-bold text-uppercase">Account details</span>
                        <h2 class="text-white mb-0 profile-hero-name">{{ page_title }}</h2>
                        <p class="text-white-50 mb-0 profile-hero-meta">
                            {{ page_description }}
                        </p>
                    </div>
                </div>

                <div class="col-lg-4 d-flex align-items-center justify-content-center justify-content-lg-end">
                    <button
                        type="button"
                        class="btn btn-sm py-2 text-xs profile-secondary-btn px-4 d-inline-flex align-items-center justify-content-center"
                        @click="cancelEdit"
                    >
                        <i class="bi bi-arrow-left me-2"></i>
                        <span>{{ is_managed_user_edit ? 'Back to Users' : 'Back to Profile' }}</span>
                    </button>
                </div>
            </div>
        </div>

        <form class="card profile-surface-card p-4 rounded-4 overflow-hidden" @submit.prevent="saveProfile">
            <div class="d-flex align-items-center gap-3 mb-4">
                <span class="settings-section-icon d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-4 text-white">
                    <i class="bi bi-pencil-square"></i>
                </span>
                <div>
                    <span class="profile-section-eyebrow fw-bold text-uppercase">Profile form</span>
                    <h5 class="text-white fw-bold mb-0 mt-1">Personal Information</h5>
                </div>
            </div>

            <div v-if="form_error" class="alert alert-danger border-0 rounded-4" role="alert">
                {{ form_error }}
            </div>

            <div v-if="is_loading" class="d-flex align-items-center gap-3 text-white-50 mb-3">
                <div class="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></div>
                <span class="text-xs">Loading user details...</span>
            </div>

            <div class="row g-3">
                <div class="col-md-6">
                    <label for="edit-profile-first-name" class="form-label profile-form-label fw-bold">First name</label>
                    <input
                        id="edit-profile-first-name"
                        type="text"
                        class="form-control form-control-sm profile-form-control"
                        v-model="form.first_name"
                        :disabled="is_loading || is_saving"
                        required
                    >
                </div>

                <div class="col-md-6">
                    <label for="edit-profile-last-name" class="form-label profile-form-label fw-bold">Last name</label>
                    <input
                        id="edit-profile-last-name"
                        type="text"
                        class="form-control form-control-sm profile-form-control"
                        v-model="form.last_name"
                        :disabled="is_loading || is_saving"
                        required
                    >
                </div>

                <div class="col-md-6">
                    <label for="edit-profile-email" class="form-label profile-form-label fw-bold">Email address</label>
                    <input
                        id="edit-profile-email"
                        type="email"
                        class="form-control form-control-sm profile-form-control"
                        v-model="form.email"
                        readonly
                        disabled
                    >
                </div>

                <div class="col-md-6">
                    <label for="edit-profile-phone" class="form-label profile-form-label fw-bold">Phone number</label>
                    <input
                        id="edit-profile-phone"
                        type="tel"
                        name="phone"
                        pattern="[0-9]{10}"
                        placeholder="0123456789"
                        class="form-control form-control-sm profile-form-control"
                        v-model="form.phone"
                        :disabled="is_loading || is_saving"
                        required
                    >
                </div>
            </div>

            <div class="d-flex justify-content-end flex-wrap mt-4 gap-3">
                <button
                    type="button"
                    class="btn btn-sm py-2 text-xs profile-secondary-btn px-4 d-inline-flex align-items-center justify-content-center"
                    @click="cancelEdit"
                    :disabled="is_saving"
                >
                    Cancel
                </button>

                <button
                    type="submit"
                    class="btn btn-sm py-2 text-xs btn-primary profile-primary-btn px-4 d-inline-flex align-items-center justify-content-center text-white"
                    :disabled="is_loading || is_saving"
                >
                    <span v-if="is_saving" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <i v-else class="bi bi-check2 me-2"></i>
                    <span>Save Changes</span>
                </button>
            </div>
        </form>
    </section>
    </div>

    <BolideAssistant :is_open="showAssistant" @close-assistant="showAssistant = false" />

</div>
